import React, { useState, useEffect } from "react";
import { connect, useSelector, useDispatch } from "react-redux";
import { Grid, Typography, CircularProgress } from "@material-ui/core";
import { useNavigate } from "react-router-dom";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import SearchIcon from "@mui/icons-material/Search";
import ChevronLeftTwoToneIcon from "@mui/icons-material/ChevronLeftTwoTone";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import { set_selected_store } from "../store/actions/menuAction";
import { clearCart } from "../store/actions/cartActions";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import useMediaQuery from "@mui/material/useMediaQuery";

const MultipleStores = function (props) {
  const [searchInput, setSearchInput] = useState("");
  const [filteredStores, setFilteredStores] = useState([]);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isReload, setIsReload] = useState(true);
  const [stores, setStores] = useState(null);

  const isDesktop = useMediaQuery("(min-width: 900px)");
  const storeInfo = useSelector((s) => s.sessionReducer?.store_details);
  const storeInfoConfig = useSelector((s) => s.sessionReducer?.store_config);
  const associatedStores = useSelector((s) => s.sessionReducer?.associated_stores);

  const [confirmPopup, setConfirmPopup] = useState(false);
  const [pendingStore, setPendingStore] = useState(null);

  const primaryColor = storeInfoConfig?.general_config?.primary_color;
  const secondaryColor = storeInfoConfig?.general_config?.secondary_color;

  const isMenuOnly = storeInfoConfig?.web_ordering_setting?.is_menu;
  const targetRoute = isMenuOnly ? (isDesktop ? "/menu" : "/menu-items") : "/menu";

  useEffect(() => {
    console.log('[MultipleStores] effect', {
      has_associated_stores: !!associatedStores,
      count: associatedStores?.length,
      ids: associatedStores?.map((s) => s?.store_id),
      is_multi_store_qr: storeInfoConfig?.web_ordering_setting?.is_multi_store_qr,
      storeInfo_store_id: storeInfo?.store_id,
    });
    if (associatedStores && associatedStores.length > 0) {
      setStores(associatedStores);
      const is_multi_store_qr = storeInfoConfig?.web_ordering_setting?.is_multi_store_qr;
      if (is_multi_store_qr === false || is_multi_store_qr === undefined || is_multi_store_qr === null || is_multi_store_qr === "") {
        const parentStore = associatedStores.find((s) => s.store_id === s.parent_store_id) || associatedStores[0];
        dispatch(set_selected_store(parentStore));
        navigate(targetRoute);
        setIsReload(false);
        return;
      }
      setFilteredStores(
        associatedStores.filter((s) => String(s.store_id) !== String(storeInfo?.store_id))
      );

      if (associatedStores.length === 1) {
        dispatch(set_selected_store(associatedStores[0]));
        navigate(targetRoute);
      }
      setIsReload(false);
    }
  }, [associatedStores]);

  useEffect(() => {
    if (filteredStores.length === 1 && !searchInput) {
      handleStoreClick(filteredStores[0]);
    }
  }, [filteredStores, searchInput]);

  const handleStoreClick = (store) => {
    const single_outlet = storeInfoConfig?.web_ordering_setting?.single_outlet_per_session;
    const addedItems = props?.cartProps?.addedItems || [];
    const currentCartStoreId = addedItems?.[0]?.store_id;

    if (single_outlet && currentCartStoreId && String(currentCartStoreId) !== String(store?.store_id)) {
    //  setPendingStore(store);
    //   setConfirmPopup(true);
      props.clearCart();
      executeSwitch(store);
    } else {
      executeSwitch(store);
    }
  };

  const executeSwitch = (store) => {
    dispatch(set_selected_store(store));
    navigate(targetRoute, { state: { selectedStore: store } });
  };

  const confirmStoreSwitch = () => {
    props.clearCart();
    setConfirmPopup(false);
    if (pendingStore) {
      executeSwitch(pendingStore);
    }
  };

  // let childStores = stores?.filter(
  //   (stores) => stores.store_id !== stores.parent_store_id
  // );

  const handleSearchInputChange = (event) => {
    const searchQuery = event.target.value;
    setSearchInput(searchQuery);
    filterStores(searchQuery);
  };

  const filterStores = (searchQuery) => {
    const filtered = stores
      ?.filter((s) => String(s.store_id) !== String(storeInfo?.store_id))
      .filter((store) =>
        store.store_name.toLowerCase().includes(searchQuery.toLowerCase())
      );
    setFilteredStores(filtered);
  };

  return (
    <>
      <div
        style={{
          backgroundColor: "white",
          minHeight: "100vh",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          fontFamily: "Satoshi, sans-serif",
        }}
      >
        <div
          style={{
            backgroundColor: "white",
            minHeight: "100vh",
            width: "100%",
            maxWidth: "480px",
            boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.05)",
            display: "flex",
            flexDirection: "column",
            boxSizing: "border-box",
          }}
        >
          {stores?.length > 1 ? (
            <>
              {/* Custom Header Bar */}
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  padding: "10px 0px",
                  borderBottom: "1px solid #EDF2F7",
                }}
              >
                {/* Left Side: Back Arrow + Brand Logo */}
                <div style={{ display: "flex", alignItems: "center" }}>
                  <IconButton
                    onClick={() => navigate("/")}
                    style={{
                      color: "black",
                      backgroundColor: "rgba(255,255,255,0.2)",
                      borderRadius: "8px",
                    }}
                  >
                    <ChevronLeftTwoToneIcon />
                  </IconButton>
                  {storeInfo?.store_display_logo && (
                    <img
                      alt="Logo"
                      src={storeInfo.store_display_logo}
                      style={{
                        height: "20px",
                        objectFit: "contain",
                      }}
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = "";
                      }}
                    />
                  )}
                </div>
              </div>

              {/* Search Bar */}
              <div style={{ padding: "20px 20px 0 20px" }}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    border: "1px solid #E2E8F0",
                    borderRadius: "10px",
                    padding: "10px 16px",
                    backgroundColor: "white",
                    boxShadow: "0px 1px 3px rgba(0, 0, 0, 0.05)",
                  }}
                >
                  <SearchIcon style={{ color: primaryColor || "#A0AEC0", marginRight: "10px", fontSize: "20px" }} />
                  <input
                    type="text"
                    value={searchInput}
                    onChange={handleSearchInputChange}
                    placeholder="Search Stores"
                    style={{
                      border: "none",
                      outline: "none",
                      width: "100%",
                      fontSize: "15px",
                      fontFamily: "Satoshi",
                      color: "#2D3748",
                    }}
                  />
                  {searchInput && (
                    <IconButton
                      type="button"
                      style={{ padding: "0px" }}
                      aria-label="clear"
                      onClick={() => {
                        setSearchInput("");
                        filterStores("");
                      }}
                    >
                      <CloseIcon style={{ fontSize: "18px", color: "#A0AEC0" }} />
                    </IconButton>
                  )}
                </div>
              </div>

              {/* Center Informational Title */}
              <Typography
                style={{
                  padding: "24px 20px 16px 20px",
                  fontSize: "15px",
                  fontFamily: "Satoshi",
                  fontWeight: "700",
                  textAlign: "center",
                  color: primaryColor || "#2B6CB0",
                }}
              >
                Please choose your preferred eatery
              </Typography>

              {/* Eatery Cards Grid */}
              <div
                style={{
                  flex: 1,
                  padding: "0 30px 24px 30px",
                  overflowY: "auto",
                }}
              >
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "1fr 1fr",
                    gap: "40px",
                    width: "100%",
                  }}
                >
                  {filteredStores &&
                    filteredStores.map((e, index) => (
                      <div
                        key={e.store_id || index}
                        onClick={() => handleStoreClick(e)}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          backgroundColor: "white",
                          border: "1px solid #EEEEEE",
                          borderRadius: "10px",
                          boxShadow: "0px 0px 21.4px 0px #0000001F",
                          padding: "4px",
                          cursor: "pointer",
                          width: "100%",
                          height: "140px",
                          boxSizing: "border-box",
                        }}
                      >
                        <img
                          alt={e?.store_name}
                          style={{
                            maxWidth: "100%",
                            maxHeight: "100%",
                            width: "auto",
                            height: "auto",
                            objectFit: "contain",
                          }}
                          src={e?.store_display_logo || e?.store_logo || "none"}
                        />
                      </div>
                    ))}
                </div>
              </div>
            </>
          ) : (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                flex: 1,
                padding: "2rem",
              }}
            >
              <CircularProgress style={{ color: primaryColor || "#2196F3" }} />
              <p style={{ marginTop: "1rem", fontFamily: "Satoshi", color: "#4A5568" }}>Loading...</p>
            </div>
          )}
        </div>
      </div>
  <Dialog
  open={confirmPopup}
  onClose={() => setConfirmPopup(false)}
  maxWidth="xs"
  fullWidth
  PaperProps={{
    style: {
      borderRadius: "20px",
      padding: "20px",
      backgroundColor: "#fff",
    },
  }}
>
  <DialogTitle
    style={{
      padding: "0px",
      marginBottom: "10px",
    }}
  >
    <Typography
      style={{
        fontFamily: "Plus Jakarta Sans",
        fontSize: "30px",
        color: primaryColor || "#000",
        fontWeight: "700",
        textAlign: "center",
      }}
    >
     <span style={{fontSize:"20px"}}>Switch Outlet?</span> 
    </Typography>
  </DialogTitle>

  <DialogContent style={{ padding: "0px", marginBottom: "20px" }}>
    <Typography
      style={{
        fontFamily: "Satoshi",
        fontSize: "14px",
        color: "#333333",
        textAlign: "left",
        fontWeight: "500",
      }}
    >
     
      Switching to {pendingStore?.store_name} will clear your cart. <br />
      Do you wish to proceed?
    </Typography>
  </DialogContent>

  <DialogActions style={{ padding: "0px", justifyContent: "flex-start", gap: "10px" }}>
    <Button
      onClick={() => setConfirmPopup(false)}
      variant="contained"
      disableElevation
      style={{
        flex: "1",
        borderRadius: "8px",
        fontSize: "14px",
        border: `1px solid ${primaryColor || "#000"}`,
        color: primaryColor || "#000",
        background:  "white"  || "#fff",
        textTransform: "none",
        fontWeight: "600",
        padding: "8px",
        boxShadow: "none",
      }}
    >
      Cancel
    </Button>

    <Button
      onClick={confirmStoreSwitch}
      variant="contained"
      disableElevation
      style={{
        flex: "1",
        borderRadius: "8px",
        fontSize: "14px",
        color:  "white"  || "#fff",
        backgroundColor: primaryColor || "#000",
        textTransform: "none",
        fontWeight: "700",
        padding: "8px",
        boxShadow: "none",
      }}
    >
      Proceed
    </Button>
  </DialogActions>
</Dialog>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    cartProps: state.cartReducer,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    clearCart: () => {
      dispatch(clearCart());
    },
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(MultipleStores);
